import React from "react";
import "./button.scss";
import { Button } from "react-bootstrap";

function CustomButton(props) {
  const { id, label, onClick, variant, className } = props;
  return (
    <>
      <Button id={id} onClick={onClick} variant={variant} className={className}>{label}</Button>
    </>
  );
}

export default CustomButton;
  